// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    offer: '',
    type: '',
    status: '',
    url: '',
};

const initialErrors = {
    offer: '',
    type: '',
    status: '',
    url: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        if (props.selectedPostBack) {
            setValues({
                offer: props.selectedPostBack.offer.id.toString(),
                type: (props.selectedPostBack.type) ? props.selectedPostBack.type.id.toString() : '',
                status: props.selectedPostBack.status.id.toString(),
                url: props.selectedPostBack.url,
            });
        }
    }, [props.selectedPostBack]);

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.put(
            `/api/postbacks/${props.selectedPostBack.id}/`, {
                offer: values.offer,
                type: values.type,
                status: values.status,
                url: values.url,
            }, abortController
        ).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.offer = (data.offer) ? data.offer[0] : '';
                _errors.type = (data.type) ? data.type[0] : '';
                _errors.status = (data.status) ? data.status[0] : '';
                _errors.url = (data.url) ? data.url[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedPostBack(null);
    };

    return (
        <DialogForm title="Изменение PostBack" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}>
            <Form initialValues={initialValues} values={values} setValues={setValues}
                  errors={errors} setErrors={setErrors}
            />
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedPostBack: PropTypes.object,
    setSelectedPostBack: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
